import { Button, Col, Form, Input, Row, Space } from 'antd';
import { nameRules } from 'common/FormValidationRules';
import { FullHeightContainerLayout } from "components";
import { diff } from 'deep-object-diff';
import _ from 'lodash';
import React, { Component } from 'react';

class ManageSystemConnectionHubSpot extends Component {

    constructor(props) {
        super(props);
        this.state = {
            connectionDefault: {
                name: '',
                description: '',
                clientId: '',
                clientSecret: ''
            },
            readOnlyView: this.props.action === "view"
        };
        this.formRef = React.createRef();
        this.emptyObject = {};
    }

    componentDidMount() {
        if (this.props.connection) {
            this.formRef.current.setFieldsValue({ ...this.props.connection });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.connection && prevProps.connection !== this.props.connection) {
            this.formRef.current.setFieldsValue({ ...this.props.connection });
        }
    }

    getFormErrors = fieldName => {
        if (this.props.formErrors && this.props.formErrors[fieldName]) {
            return {
                help: this.props.formErrors[fieldName],
                validateStatus: "error"
            }
        }
        return this.emptyObject;
    }

    onFormSubmit = (formData) => {
        let connection = { ...formData };
        if (this.props.action === "create") {
            connection.active = true;
            this.props.onSave(connection);
        }
        else {
            let diffObject = diff(this.props.connection, connection);
            let updatedObject = {};
            for (let key in diffObject) {
                if (diffObject[key] !== undefined) {
                    updatedObject[key] = connection[key];
                }
            }
            if (_.isEmpty(updatedObject) === false) {
                updatedObject.version = this.props.connection.version;
            }

            this.props.onSave(this.props.connection.connectionId, updatedObject);
        }
    }

    isReadOnlyView = () => {
        return (this.state.readOnlyView || !(this.props.permission.canEdit || this.props.permission.canAdd));
    }

    isSaveAllowed = () => {
        if (this.props.action === "edit") {
            return this.props.permission.canEdit;
        }
        else if (this.props.action === "create") {
            return this.props.permission.canAdd;
        }
        return false;
    }

    render() {
        return (
            <Form
                layout="horizontal"
                labelAlign="right"
                labelCol={{ md: { span: 24 }, lg: { span: 6 }, xl: { span: 5 }, xxl: { span: 3 } }}
                ref={this.formRef}
                name="basic"
                onFinish={this.onFormSubmit}
                initialValues={this.state.connectionDefault}
                onValuesChange={this.props.onValuesChanged}
                style={{ height: "100%" }}>
                <FullHeightContainerLayout
                    showFooter={true}
                    content={
                        <>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("name")}
                                label="Connection Name"
                                name={["name"]}
                                rules={nameRules}
                                hasFeedback>
                                <Input placeholder="Connection Name" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("description")}
                                label="Description"
                                name={["description"]}
                                rules={[]}
                                hasFeedback>
                                <Input placeholder="Description (Optional)" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("clientId")}
                                label="Client ID"
                                name={["clientId"]}
                                rules={[{ required: true, message: `Client ID is required` }]}
                                hasFeedback>
                                <Input placeholder="HubSpot App Client ID" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("clientSecret")}
                                label="Client Secret"
                                name={["clientSecret"]}
                                rules={this.props.action === "create" ? [{ required: true, message: `Client Secret is required` }] : []}
                                hasFeedback>
                                <Input.Password placeholder={this.props.action === "create" ? "HubSpot App Client Secret" : "***************************"} readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                        </>
                    }
                    footer={
                        <Row>
                            <Col span={24} className="footer-right-column">
                                <Space>
                                    <Button onClick={this.props.onCancel}>Cancel</Button>
                                    <Button type="primary" htmlType="submit" disabled={this.isReadOnlyView() || !this.isSaveAllowed()}>Connect to HubSpot</Button>
                                </Space>
                            </Col>
                        </Row>
                    }>
                </FullHeightContainerLayout>
            </Form>
        );
    }
}

export default ManageSystemConnectionHubSpot;
